export default "__VITE_ASSET__f7751f95__"